import { node } from 'prop-types';

const Radio = (props) => {
  return props.children;
};

Radio.propTypes = {
  /** The only thing that renders */
  children: node,
};

export default Radio;
